// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"306":"0eaccd33","676":"1a319aac","917":"c1666b20"}[chunkId] + ".chunk.css";
};